import { zonedParts } from './zoned-time';
const WALL_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
export function isWallClock(value) {
    return WALL_PATTERN.test(value) && dayExists(value.slice(0, 10)) && timeExists(value.slice(11));
}
export function isCalendarDay(value) {
    return DAY_PATTERN.test(value) && dayExists(value);
}
/** Duvar saatinin gün ve saat parçaları — biçim doğrulanmışsa güvenli. */
export function wallClockDay(value) {
    return value.slice(0, 10);
}
export function wallClockTime(value) {
    return value.slice(11, 16);
}
export function joinWallClock(day, time) {
    return `${day}T${time}`;
}
/** UTC ISO damgası → `timezone` dilimindeki duvar saati. Geçersiz girdi boş dizedir. */
export function isoToWallClock(iso, timezone) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return '';
    const parts = zonedParts(date, timezone);
    return `${parts.day}T${parts.time}`;
}
/**
 * `timezone` dilimindeki duvar saati → UTC ISO damgası.
 *
 * `Intl` yalnız ILERI yönde (damga → dilim) çalışır; ters yön sabit nokta
 * yinelemesiyle bulunur: damgayı UTC sanıp başla, dilime çevir, farkı geri
 * uygula. Ofset yılda en çok bir kez değiştiği için iki tur yeter; üçüncü tur
 * yaz saati sınırındaki uç durumlar için emniyet payıdır.
 *
 * YAZ SAATİ BOŞLUĞU (ör. New York'ta 08.03.2026 02:30 HİÇ YAŞANMAZ): yineleme
 * salınır ve tur sınırında en yakın GERÇEK damgaya oturur. Ürün için doğru
 * davranış budur; hata fırlatmak formu kilitlerdi.
 */
export function wallClockToIso(wall, timezone) {
    if (!WALL_PATTERN.test(wall))
        return '';
    const target = Date.parse(`${wall}:00Z`);
    if (Number.isNaN(target))
        return '';
    let stamp = target;
    for (let attempt = 0; attempt < 3; attempt += 1) {
        const parts = zonedParts(new Date(stamp), timezone);
        const seen = Date.parse(`${parts.day}T${parts.time}:00Z`);
        const drift = target - seen;
        if (drift === 0)
            break;
        stamp += drift;
    }
    return new Date(stamp).toISOString();
}
/** "Şu an" değerinin `timezone` dilimindeki duvar saati — geçmiş kuralının tabanı. */
export function nowWallClock(timezone, now = new Date(Date.now())) {
    const parts = zonedParts(now, timezone);
    return `${parts.day}T${parts.time}`;
}
/**
 * TAKVİM GÜNÜ → ANIN İKİ UCU. Süzgeç alanlarının tek doğruluk kaynağı.
 *
 * KUSUR ÖLÇÜLDÜ (QA, 16.09.2026 · panel e-posta gönderim görünümü): ekran
 * seçicinin ürettiği DUVAR SAATİ gününe (`2026-09-16`) doğrudan `Z` ekliyordu
 * (`${day}T00:00:00.000Z`). O dize UTC gününün başıdır, PERSONELİN gününün
 * başı değil. Europe/Istanbul'da (UTC+3, ana pazar) sonuç şuydu:
 *   · "Başlangıç: bugün" → bugün yerel 01:30'daki satır listede YOK,
 *   · "Bitiş: bugün"     → YARIN yerel 01:00'daki satır listede VAR.
 * Yani personel her gün 00:00-03:00 arasını "yok" sanıyor, ertesi günün ilk üç
 * saatini bugüne ait sanıyordu. UTC'de doğru göründüğü için gözden kaçmıştı.
 *
 * GÜN SONU, "23:59" DEĞİL, ERTESİ GÜNÜN BAŞINDAN BİR MİLİSANİYE ÖNCEDİR:
 * `23:59`a sabitlemek son dakikanın 59 saniyesini dışarıda bırakırdı; yaz saati
 * geçişinde (gün 23 ya da 25 saat sürer) sabit saat zaten yanlış olurdu.
 * `wallClockToIso` dilimi `Intl`e açıkça verir, bu yüzden geçiş günlerinde de
 * doğru ANA oturur.
 *
 * Geçersiz gün boş dize döner: çağıran `''` ise alanı sorguya HİÇ koymaz.
 *
 * BİÇİM DOĞRULAMAK YETMEZ, GÜNÜN VAR OLDUĞU DA SORULUR (QA, 16.09.2026).
 * Eski hâli yalnız `DAY_PATTERN`e bakıyordu ve VAR OLMAYAN takvim günü sessizce
 * KAYIYORDU: `startOfDayIso('2026-02-29', 'Europe/Istanbul')` →
 * `2026-02-28T21:00:00Z`, yani 1 MART'ın yerel gün başı. Sonuç "geçersiz girdi
 * boş döner" sözleşmesini deliyordu: çağıran `''` beklerken geçerli ama YANLIŞ
 * bir an alıyor ve süzgeci sessizce kaydırıyordu. Bugün arayüzden erişilemez
 * (`parseWallClockInput` geçersiz günü `null` döndürür) — yani kusur latent'ti;
 * ikinci bir çağıran eklendiğinde canlı olurdu.
 */
export function startOfDayIso(day, timezone) {
    if (!isCalendarDay(day))
        return '';
    return wallClockToIso(`${day}T00:00`, timezone);
}
export function endOfDayIso(day, timezone) {
    if (!isCalendarDay(day))
        return '';
    const ertesi = wallClockToIso(`${addDays(day, 1)}T00:00`, timezone);
    if (ertesi === '')
        return '';
    return new Date(Date.parse(ertesi) - 1).toISOString();
}
/**
 * Tarayıcının (ya da sunucunun) kendi saat dilimi — süzgeç alanlarının tabanı.
 *
 * Etkinlik ekranlarında dilim ETKİNLİĞİN alanından gelir; personel süzgeci ise
 * etkinliğe değil, personelin oturduğu yere bağlıdır. `Intl` dilimi veremezse
 * ürünün ana pazarına düşülür — `''` döndürmek `wallClockToIso`u sessizce UTC
 * davranışına geri sokardı ve düzeltilen kusur geri gelirdi.
 */
export function browserTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Istanbul';
}
/** Locale'e göre haftanın ilk günü — TR pazartesi, EN pazar. */
export const WEEK_STARTS_ON = { tr: 1, en: 0 };
export function monthOfDay(day) {
    return day.slice(0, 7);
}
export function addDays(day, delta) {
    const date = new Date(`${day}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + delta);
    return date.toISOString().slice(0, 10);
}
export function addMonths(month, delta) {
    const date = new Date(`${month}-01T00:00:00Z`);
    date.setUTCMonth(date.getUTCMonth() + delta);
    return date.toISOString().slice(0, 7);
}
/**
 * Ayın 6×7 hücrelik ızgarası. Sabit 42 hücre: ay değişince ızgaranın yüksekliği
 * ZIPLAMAZ (README 4.8 — katman açıkken düzen oynamaz).
 */
export function monthGrid(month, weekStartsOn) {
    const first = new Date(`${month}-01T00:00:00Z`);
    if (Number.isNaN(first.getTime()))
        return [];
    const lead = (first.getUTCDay() - weekStartsOn + 7) % 7;
    const start = new Date(first);
    start.setUTCDate(start.getUTCDate() - lead);
    const cells = [];
    for (let index = 0; index < 42; index += 1) {
        const cursor = new Date(start);
        cursor.setUTCDate(cursor.getUTCDate() + index);
        const day = cursor.toISOString().slice(0, 10);
        cells.push({
            day,
            dayOfMonth: cursor.getUTCDate(),
            inMonth: day.slice(0, 7) === month,
            weekday: cursor.getUTCDay(),
        });
    }
    return cells;
}
/** Izgara başlığının gün adları — locale'in hafta başlangıcına göre döndürülmüş 0-6 sırası. */
export function weekdayOrder(weekStartsOn) {
    return [0, 1, 2, 3, 4, 5, 6].map((index) => (index + weekStartsOn) % 7);
}
/* --------------------------------------------------------------------------
 * BİÇİMLEME VE AYRIŞTIRMA — metin girişi kaldırılmadı (erişilebilirlik).
 * ----------------------------------------------------------------------- */
/** Locale'in tarih sırası: TR gün.ay.yıl, EN ay/gün/yıl. */
const DATE_ORDER = {
    tr: { dayFirst: true, sep: '.' },
    en: { dayFirst: false, sep: '/' },
};
/** Duvar saati → kullanıcıya gösterilen metin. Geçersizse boş dize. */
export function formatWallClock(value, locale, mode) {
    if (mode === 'time')
        return timeExists(value.slice(0, 5)) ? value.slice(0, 5) : '';
    const day = value.slice(0, 10);
    if (!isCalendarDay(day))
        return '';
    const { dayFirst, sep } = DATE_ORDER[locale];
    const [year, month, dayOfMonth] = day.split('-');
    const date = dayFirst
        ? `${dayOfMonth}${sep}${month}${sep}${year}`
        : `${month}${sep}${dayOfMonth}${sep}${year}`;
    if (mode === 'date')
        return date;
    const time = value.slice(11, 16);
    return timeExists(time) ? `${date} ${time}` : date;
}
/** Kullanıcıya gösterilen biçimin ipucu maskesi (`GG.AA.YYYY SS:dd`). */
export function wallClockMask(locale, mode, tokens) {
    if (mode === 'time')
        return `${tokens.hour}:${tokens.minute}`;
    const { dayFirst, sep } = DATE_ORDER[locale];
    const date = dayFirst
        ? `${tokens.day}${sep}${tokens.month}${sep}${tokens.year}`
        : `${tokens.month}${sep}${tokens.day}${sep}${tokens.year}`;
    return mode === 'date' ? date : `${date} ${tokens.hour}:${tokens.minute}`;
}
/**
 * Serbest yazılan metin → duvar saati. Çözemezse `null`.
 *
 * Locale sırası uygulanır; ama YIL ÖNDE yazılmış girdi (`2026-09-12 18:00`)
 * her iki dilde de kabul edilir — yapıştırılan ISO değeri sessizce reddedilmez.
 */
export function parseWallClockInput(text, locale, mode) {
    const groups = text.match(/\d+/g);
    if (!groups)
        return null;
    if (mode === 'time') {
        const [rawHour, rawMinute] = groups;
        if (rawHour === undefined || rawMinute === undefined)
            return null;
        const only = `${pad(rawHour)}:${pad(rawMinute)}`;
        return timeExists(only) ? only : null;
    }
    if (groups.length < 3)
        return null;
    const yearFirst = groups[0]?.length === 4;
    const [first, second, third] = groups;
    const year = yearFirst ? first : third;
    const dayFirst = yearFirst ? false : DATE_ORDER[locale].dayFirst;
    const month = yearFirst ? second : dayFirst ? second : first;
    const dayOfMonth = yearFirst ? third : dayFirst ? first : second;
    if (year.length !== 4)
        return null;
    const day = `${year}-${pad(month)}-${pad(dayOfMonth)}`;
    if (!isCalendarDay(day))
        return null;
    if (mode === 'date')
        return day;
    const time = `${pad(groups[3] ?? '0')}:${pad(groups[4] ?? '0')}`;
    return timeExists(time) ? `${day}T${time}` : null;
}
/** Saat listesi: `step` dakikalık adımlarla `HH:mm` değerleri. */
export function timeOptions(step) {
    const safeStep = Number.isFinite(step) && step > 0 && step <= 60 ? Math.floor(step) : 15;
    const values = [];
    for (let minutes = 0; minutes < 24 * 60; minutes += safeStep) {
        values.push(`${pad(String(Math.floor(minutes / 60)))}:${pad(String(minutes % 60))}`);
    }
    return values;
}
function pad(value) {
    return value.length >= 2 ? value.slice(-2) : `0${value}`;
}
function dayExists(day) {
    if (!DAY_PATTERN.test(day))
        return false;
    const date = new Date(`${day}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === day;
}
function timeExists(time) {
    if (!/^\d{2}:\d{2}$/.test(time))
        return false;
    const hour = Number(time.slice(0, 2));
    const minute = Number(time.slice(3, 5));
    return hour <= 23 && minute <= 59;
}
//# sourceMappingURL=wall-clock.js.map